import { render, staticRenderFns } from "./DragAndDropPlaceholder.vue?vue&type=template&id=1d109ab9&scoped=true"
import script from "./DragAndDropPlaceholder.vue?vue&type=script&lang=js"
export * from "./DragAndDropPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./DragAndDropPlaceholder.vue?vue&type=style&index=0&id=1d109ab9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d109ab9",
  null
  
)

export default component.exports